import { Container } from "@/components/ui/container";
import Title from "@/components/ui/title";
import { BRANDS } from "@/views/home/constants/brands";
import Image from "next/image";
import CustomIcon from "@/components/ui/custom-icon";
import Link from "next/link";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";

const Brands = () => {
  const t = useTranslations("home");

  return (
    <div className={S.backgroundWrapper}>
      <Container>
        <Title variant={"white"}>{t("ourBrands")}</Title>
      </Container>

      <div className={S.brandsWrapper}>
        {BRANDS.map(brand => (
          <Link className={S.brand} href={`/brands/${brand.name}`} key={brand.name}>
            <Image src={brand.image} alt={brand.name} className={S.brandImg} width={800} height={800} />
            <div className={S.brandBackground}>
              <div className={S.iconContainer}>
                <CustomIcon fileName={`icon-${brand.name}`} className={S.brandIcon} />
                <CustomIcon fileName={`icon-open-${brand.name}`} className={S.openIcon} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Brands;
